function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
import TonePlayer from './tone-step/tone-player';
import globals from '../../utils/globals';
var trackEnvironmentIntro = true;
var EnvironmentStep = /*#__PURE__*/function (_Component) {
  function EnvironmentStep(props) {
    var _this;
    _classCallCheck(this, EnvironmentStep);
    _this = _callSuper(this, EnvironmentStep, [props]);
    _this.state = {
      currentView: EnvironmentStep.INTRO
    };
    _this.gotoView = _this.gotoView.bind(_this);
    if (trackEnvironmentIntro) {
      window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', globals.STEP_TYPE_ENVIRONMENT_INTRO, props.content.Id);
      trackEnvironmentIntro = false;
    }
    return _this;
  }
  _inherits(EnvironmentStep, _Component);
  return _createClass(EnvironmentStep, [{
    key: "gotoView",
    value: function gotoView(view) {
      window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', globals.STEP_TYPE_ENVIRONMENT, this.props.content.Id);
      this.setState({
        currentView: view
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        content = _this$props.content,
        onNextClick = _this$props.onNextClick,
        points = _this$props.points;
      var currentView = this.state.currentView;
      return /*#__PURE__*/React.createElement(StepWrapper, {
        backgroundImage: content.BackgroundImage,
        stepClassNames: "step--environment"
      }, /*#__PURE__*/React.createElement(StepHeader, {
        icon: content.StepHeaderIcon,
        header: content.StepHeaderTitle
      }), currentView === EnvironmentStep.INTRO && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        className: "step__title"
      }, content.Heading), /*#__PURE__*/React.createElement("p", {
        className: "step__body"
      }, content.Body), /*#__PURE__*/React.createElement("button", {
        className: "step-button",
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.gotoView(EnvironmentStep.SOUND);
        }
      }, content.NextButtonLabel)), currentView === EnvironmentStep.SOUND && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TonePlayer, {
        soundFile: content.SoundFile,
        onFinishedPlaying: function onFinishedPlaying() {
          return _this2.gotoView(EnvironmentStep.QUESTION);
        },
        controlsEnabled: false
      })), currentView === EnvironmentStep.QUESTION && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        className: "step__title"
      }, content.Question), content.ResponseOptions.map(function (responseOption, index) {
        return /*#__PURE__*/React.createElement("button", {
          className: "step-button"
          // eslint-disable-next-line react/no-array-index-key
          ,
          key: index,
          onClick: function onClick(e) {
            e.preventDefault();
            onNextClick({
              points: responseOption.TriggerPoints ? points : 0
            });
          }
        }, responseOption.Label);
      })));
    }
  }], [{
    key: "INTRO",
    get: function get() {
      return 'intro';
    }
  }, {
    key: "SOUND",
    get: function get() {
      return 'sound';
    }
  }, {
    key: "QUESTION",
    get: function get() {
      return 'question';
    }
  }]);
}(Component);
EnvironmentStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default EnvironmentStep;